import createIcon from '../../createIcon';

/**
 * @component @name PinDrop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggOEMxOCA0LjY5IDE1LjMxIDIgMTIgMkM4LjY5IDIgNiA0LjY5IDYgOEM2IDEyLjUgMTIgMTkgMTIgMTlDMTIgMTkgMTggMTIuNSAxOCA4Wk0xMCA4QzEwIDYuOSAxMC45IDYgMTIgNkMxMy4xIDYgMTQgNi45IDE0IDhDMTQgOS4xIDEzLjExIDEwIDEyIDEwQzEwLjkgMTAgMTAgOS4xIDEwIDhaTTUgMjBWMjJIMTlWMjBINVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PinDrop = createIcon('PinDrop', [
  [
    'path',
    {
      d: 'M18 8C18 4.69 15.31 2 12 2C8.69 2 6 4.69 6 8C6 12.5 12 19 12 19C12 19 18 12.5 18 8ZM10 8C10 6.9 10.9 6 12 6C13.1 6 14 6.9 14 8C14 9.1 13.11 10 12 10C10.9 10 10 9.1 10 8ZM5 20V22H19V20H5Z',
      key: 'je3zgl',
    },
  ],
]);

export default PinDrop;
